export default {
  masterChef: {
    41: '0xFA3Df718d96B95fF5E28f29Ecf02Cb48C92DecBe',
  },
  lotteryV2: {
    41: '0x0000000000000000000000000000000000000002', // TODO: Replace temp address with a normal one.
  },
  multiCall: {
    41: '0x91461a0d49B66Ca6Eb72F60efadd8C1253059EB2',
  },
  pancakeProfile: {
    41: '0x0000000000000000000000000000000000000003', // TODO: Replace temp address with a normal one.
  },
  pancakeRabbits: {
    41: '0x0000000000000000000000000000000000000004', // TODO: Replace temp address with a normal one.
  },
  bunnyFactory: {
    41: '0x0000000000000000000000000000000000000005', // TODO: Replace temp address with a normal one.
  },
  claimRefund: {
    41: '0x0000000000000000000000000000000000000006', // TODO: Replace temp address with a normal one.
  },
  pointCenterIfo: {
    41: '0x0000000000000000000000000000000000000007', // TODO: Replace temp address with a normal one.
  },
  bunnySpecial: {
    41: '0x0000000000000000000000000000000000000008', // TODO: Replace  address with a normal one.
  },
  tradingCompetition: {
    41: '0x0000000000000000000000000000000000000009', // TODO: Replace temp address with a normal one.
  },
  easterNft: {
    41: '0x0000000000000000000000000000000000000010', // TODO: Replace temp address with a normal one.
  },
  cakeVault: {
    41: '0x234ef61F69340A36f2ade2Bc62cEE87F90B9685D',
  },
  predictions: {
    41: '0x0000000000000000000000000000000000000012', // TODO: Replace temp address with a normal one.
  },
  chainlinkOracle: {
    41: '0x0000000000000000000000000000000000000013', // TODO: Replace temp address with a normal one.
  },
  bunnySpecialCakeVault: {
    41: '0x0000000000000000000000000000000000000014', // TODO: Replace temp address with a normal one.
  },
  bunnySpecialPrediction: {
    41: '0x0000000000000000000000000000000000000015', // TODO: Replace temp address with a normal one.
  },
  farmAuction: {
    41: '0x0000000000000000000000000000000000000016', // TODO: Replace temp address with a normal one.
  },
  bunnySpecialLottery: {
    41: '0x0000000000000000000000000000000000000017', // TODO: Replace temp address with a normal one.
  },
}
